<template>
  <div v-show="show" class="foremanInfo-container">
      <div class="bg"></div>
      <div class="foremanInfo-edit">
        <div class="title">值班长意见</div>
        <div class="input">
          <div>
            <p>分发平台：</p>
            <div v-click-outside="closeSelect" :class="{'select-box': true}">
              <span @click="showSelect = !showSelect">{{text || "请选择"}}</span>
              <dl v-show="showSelect">
                <li v-for="(item,index) in list" :key="index" @click="selectItem(item)" :class="{active: item.selected, lastItem: true}">{{item.title}}
                </li>
              </dl>
            </div>
          </div>
          <div>
            <p>留言：</p>
            <textarea v-model="foreman_view" maxlength="50" placeholder="请输入值班长意见"></textarea>
            <div class="num">{{foreman_view.length}}/50</div>
          </div>
        </div>
        <div class="btns">
          <div @click="save" class="btn g">保存</div>
          <div @click="close" class="btn">取消</div>
        </div>
      </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import vClickOutside from "v-click-outside";

export default {
  name: 'confirm',
  directives: {
      clickOutside: vClickOutside.directive
  },
  data() {
    return {
      foreman_view: '',
      text: '',
      list: [{
        title: '电视',
        selected: false
      },{
        title: '新媒体',
        selected: false
      },{
        title: '直播',
        selected: false
      },{
        title: '海报',
        selected: false
      },],
      show: true,
      showSelect: false,
      config: {
        id: '',
        foreman_issue_platform: '',
        foreman_view: '',
        arr: []
      },
      r: null
    }
  },
  methods: {
    closeSelect() {
      this.showSelect = false;
    },
    selectItem(item) {
      item.selected = !item.selected
      let arr = []
      this.list.forEach(el => {
        if(el.selected){
          arr.push(el.title)
        }
      })

      this.text = arr.join(',')
    },
    open(c, r) {
      this.config = JSON.parse(JSON.stringify(c))
      this.foreman_view = this.config.foreman_view
      this.text = this.config.foreman_issue_platform
      if(this.config.arr && this.config.arr.length > 0){
        this.config.arr.forEach(el => {
          this.list.forEach(el1 => {
            if(el == el1.title){
              el1.selected = true
            }
          })
        })
      }
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    },
    save() {
      let info = {
        id: this.config.id,
        foreman_view: this.foreman_view,
        foreman_issue_platform: this.text
      }
      common.myFetch(apis.newTopicForemanOpt,info).then(res => {
        if(res){
          this.$toast(res);
          this.show = false
          this.r(true)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .select-box {
  border-radius: 2px;
  min-width: 120px;
  height: 30px;
  outline: none;
  padding: 0px 20px;
  background: none;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background: rgba(185,195,195,0.2);
}
.select-box.day {
  min-width: 82px;
  padding: 0 12px 0 20px;
}
.select-box .enter {
  width: 100%;
  height: 100%;
  background-color: transparent;
  color: #050f0f;
  font-size: 14px;
  margin-top: -1px;
}
.select-box .enter::placeholder {
  color: #b9c3c3;
}
.select-box span {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 30px;
  position: relative;
  text-align: left;
  font-size: 14px;
  box-sizing: border-box;
  padding-right: 20px;
  color: #323B4B;
}
.select-box span::after {
  content: "";
  display: block;
  width: 10px;
  height: 6px;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  background: url('../../assets/img/common/down.png') no-repeat;
  background-position: right center;
}
.select-box span.down::after {
  transform: rotate(-180deg);
}
.select-box span.notEmpty {
  color: #050f0f;
}
.select-box .sublist {
  position: relative;
  box-shadow: none;
}
.select-box dl {
  position: absolute;
  left: 0px;
  top: 26px;
  width: 100%;
  margin-top: 10px;
  background: #fff;
  z-index: 9999;
  border-radius: 4px;
  box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
  max-height: 300px;
  overflow-y: auto;
}
.select-box dl .listItem {
  display: flex;
  align-items: flex-start;
}
.select-box dl .expander {
  margin: 12px 6px 0 20px;
}
.select-box dl .listContainer {
  flex: 1;
}
.select-box dl .childItem:hover {
  background: rgba(65, 180, 140, 0.15);
}
.select-box dl .lastItem {
  padding-left: 20px !important;
}
.select-box dl .lastItem:hover {
  background: rgba(65, 180, 140, 0.15);
}
.select-box dl li {
  line-height: 30px;
  margin: 0px !important;
  font-size: 14px;
  color: #050f0f !important;
}
.select-box dl li.active {
  position: relative;
}
.select-box dl li.active::after {
  content: "";
  display: block;
  width: 14px;
  height: 11px;
  background: url('../../assets/img/common/select.svg') no-repeat;
  background-position: right center;
  position: absolute;
  right: 20px;
  top: 0px;
  bottom: 0px;
  margin: auto;
}

  .foremanInfo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .foremanInfo-edit {
      width: 418px;
      height: 434px;
      background: #F9F9F9;
      border-radius: 4px;
      padding: 30px;
      box-sizing: border-box;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #050F0F;
        line-height: 18px;
        margin-bottom: 26px;
      }

      .input {
        display: flex;
        flex-direction: column;

        & > div {
          position: relative;
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;
          width: 100%;

          &:nth-last-of-type(1) {
            margin-bottom: 26px;
          }
          
          p {
            font-weight: bold;
            font-size: 14px;
            color: #050F0F;
            line-height: 20px;
            margin-bottom: 10px;
          }

          input {
            width: 100%;
            height: 32px;
            background: rgba(185,195,195,0.2);
            border-radius: 2px;
            outline: none;
            border: none;
            padding: 0 20px;
            box-sizing: border-box;
          }

          textarea {
            width: 100%;
            height: 160px;
            background: rgba(185,195,195,0.2);
            border-radius: 2px;
            resize: none;
            outline: none;
            border: none;
            padding: 10px 20px;
            box-sizing: border-box;

            &::placeholder {
              color: #B9C3C3;
            }
          }

          .num {
            position: absolute;
            right: 10px;
            bottom: 10px;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #829191;
          }
        }
      }

      .btns {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 32px;
          background: #B9C3C3;
          border-radius: 4px;
          font-weight: bold;
          font-size: 14px;
          color: #FFFFFF;
          user-select: none;
          cursor: pointer;

          &.g {
            background: #41B48C;
            margin-right: 20px;
          }
        }
      }
    }
}
</style>
